import React from 'react';
import './Banner.css'
// ____________________________ banner part ______ 
const Banner = () => {
               return (
                              <div className=' banner '>
                                             <div class=" banner-text ">
                                                  
                                                            <h1 className=' text-white'>GATAWAY</h1>
                                             <h4  className=' text-white align-items-center  '>
                                             Our Getaway Often Packs are
multi-night packages designed to let
you escape longer for less.             </h4>            
                                             </div>
                      
                              </div>
               );
};

export default Banner;